import React, { useState, useEffect, useContext } from 'react'
import { Link, useNavigate } from "react-router-dom";
import { useCookies } from 'react-cookie';
import axios from 'axios';
import { BASE_URL } from '../api/api';
import { Auth } from '../context/Auth';
import '../styles/Header.scss'

const Header = () => {
    const navigate = useNavigate();
    const [cookies, setCookie] = useCookies(['token', 'userId', 'isLoggedIn', 'channelId']);
    const [, , removeCookie] = useCookies();
    const [showProfileSideBar, setShowProfileSideBar] = useState(false);
    const [userDetails, setUserDetails] = useState(JSON.parse(window.sessionStorage.getItem("userDetails")));
    const [showContent, setShowContent] = useState(false);
    const auth = useContext(Auth);

    function getColorForLetter(letter) {
        const colors = {
            'A': '#8B0000', 'B': '#8B4513', 'C': '#8B008B', 'D': '#556B2F', 'E': '#2F4F4F',
            'F': '#4682B4', 'G': '#696969', 'H': '#00008B', 'I': '#8B008B', 'J': '#A52A2A',
            'K': '#556B2F', 'L': '#696969', 'M': '#8B4513', 'N': '#8B0000', 'O': '#8B4513',
            'P': '#2F4F4F', 'Q': '#4682B4', 'R': '#556B2F', 'S': '#00008B', 'T': '#8B008B',
            'U': '#8B4513', 'V': '#2F4F4F', 'W': '#696969', 'X': '#8B0000', 'Y': '#4682B4',
            'Z': '#556B2F'
        };

        const upperCaseLetter = letter.toUpperCase();
        return colors[upperCaseLetter] || '#ffffff'; // Default to black if no color is found
    }

    const handleCreateChannel = () => {
        navigate("/create-channel");
    }

    const handleSignUp = () => {
        navigate("/login");
    }

    const handleProfileIconClick = () => {
        if (showProfileSideBar === false) {
            setShowProfileSideBar(true)

        } else {
            setShowProfileSideBar(false)
        }
    }

    const handelLogoOut = () => {
        // Clear Cookies and storage
        removeCookie('token');
        removeCookie('userId');
        removeCookie('isLoggedIn');
        removeCookie('channelId');
        window.sessionStorage.clear();
        window.localStorage.clear();
        setShowProfileSideBar(false);
        setShowContent(false);
        navigate("/");
        window.location.reload();
    }

    useEffect(() => {
        if (cookies.userId) {
            axios.post(`${BASE_URL}/api/auth/fetch-user-details`, { userId: cookies.userId })
                .then(res => {
                    const user = res.data.user
                    window.sessionStorage.setItem("userDetails", JSON.stringify({ firstName: user.firstName, lastName: user.lastName, username: user.username }));
                    setUserDetails(JSON.parse(window.sessionStorage.getItem("userDetails")));
                    setShowContent(true);
                })
                .catch(err => console.log(err))
        }
    }, [cookies.userId])

    console.log(cookies);

    const visitUserChannel = () => {
        auth.authReducerDispatch({ type: "updateVisitedChannelId", payload: auth.authState.channelId })

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `${cookies.token}`
        };

        axios.post(`${BASE_URL}/api/channels/fetch-channel`, {
            channelId: auth.authState.channelId,
            requestingUserId: auth.authState.channelId
        }, { headers: headers })
            .then(res => {
                const data = res.data.channelData;
                console.log(res, "Channel Fetched in Header.js")
                navigate(`/my-channel/${data.channelHandle}?id=${auth.authState.channelId}`);
            })
            .catch(err => console.log(err, "Error!, Fecthing channel details"))
    }

    return (
        <div className='header'>
            {/* <img className='header__company-logo' src={Logo} alt="logo" /> */}
            <Link to="/" className='header__company-logo' >ProjectY</Link>
            <div className="header__search-bar-container">
                <input className='header__search-bar' placeholder='Search Channel...' type="search" />
                <p className='header__search-icon-box'>
                    <span className="material-symbols-outlined">
                        search
                    </span>
                </p>
            </div>
            <div className='header__links-container'>
                <ul className="header__links">
                    {
                        !auth.authState.channelId && <>
                            {
                                showContent && <li onClick={handleCreateChannel}>+ Create Channel</li>
                            }
                        </>
                    }

                    {!cookies.isLoggedIn && <li className="header__login-link" onClick={handleSignUp}>Login</li>}
                </ul>
                {
                    showContent && <div className='header__user-info' style={{ backgroundColor: getColorForLetter(userDetails.firstName[0]) }} onClick={handleProfileIconClick}>
                        <div>
                            <p >
                                <span>{userDetails.firstName[0]}</span>
                            </p>
                        </div>
                    </div>
                }
            </div>
            {
                showProfileSideBar && <>
                    {
                        showContent && <div className="header__user-detail-sidebar">
                            <div className='header__sidebar-user-info'>
                                <h4>{userDetails.firstName + " " + userDetails.lastName}</h4>
                                <p className='header__username'>@{userDetails.username}</p>
                                <button className='header__user-sidebar-links' onClick={visitUserChannel}>
                                    <span className="material-symbols-outlined">
                                        settings
                                    </span>
                                    My Channel
                                </button>
                                <Link to="/manage-account" className='header__user-sidebar-links'>
                                    <span className="material-symbols-outlined">
                                        manage_accounts
                                    </span>
                                    Manage Account
                                </Link>
                                <Link to="/channel-settings" className='header__user-sidebar-links'>
                                    <span className="material-symbols-outlined">
                                        settings
                                    </span>
                                    Channel Settings
                                </Link>
                            </div>
                            <button className='header__logout-btn' onClick={handelLogoOut}>Log Out</button>
                        </div>
                    }
                </>
            }
        </div>
    )
}

export default Header